'use strict';
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import 'swiper/css';

class SliderShop {
    static init(scope = document) {
        if (scope === document && document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => SliderShop.init(scope), {once: true});
            return;
        }

        scope.querySelectorAll('.active .js-one-item-shop').forEach(slider => {
            if (slider.swiper || slider.dataset.swiperInitialized === 'true') return;

            const slides = Array.from(slider.children);
            if (!slides.length) return;

            const wrapper = document.createElement('div');
            wrapper.className = 'swiper-wrapper';
            slides.forEach(slide => {
                slide.classList.add('swiper-slide');
                wrapper.append(slide);
            });
            slider.append(wrapper);
            slider.classList.add('swiper');

            const holder = slider.closest('.slider-holder') || slider.parentElement;
            const previousButton = document.createElement('button');
            previousButton.type = 'button';
            previousButton.className = 'shop-slider-arrow shop-slider-prev';
            previousButton.setAttribute('aria-label', 'Previous slide');

            const nextButton = document.createElement('button');
            nextButton.type = 'button';
            nextButton.className = 'shop-slider-arrow shop-slider-next';
            nextButton.setAttribute('aria-label', 'Next slide');

            holder.append(previousButton, nextButton);
            slider.dataset.swiperInitialized = 'true';

            new Swiper(slider, {
                modules: [Navigation],
                slidesPerView: 1,
                navigation: {
                    prevEl: previousButton,
                    nextEl: nextButton,
                    disabledClass: 'shop-slider-arrow--disabled',
                },
            });
        });
    }
}

export {SliderShop};